import React, { createContext, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "../api/axiosConfig";
import { useNotification } from "./NotificationContext";

const SearchContext = createContext();

export function SearchProvider({ children }) {
  const [searchQuery, setSearchQuery] = useState("");
  const [userSearchQuery, setUserSearchQuery] = useState("");
  const [loadingHttpSearch, setLoadingHttpSearch] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { addNotification } = useNotification();

  const handleSearch = async (query) => {
    if (query === undefined) return;
    if (!query.startsWith("http") && query.length > 100) {
      addNotification("Search Error", "Search query cannot exceed 100 characters.", "error");
      return;
    }

    try {
      if (query.startsWith("http")) {
        console.log("🔄 Searching for new recipe...");
        setLoadingHttpSearch(true);
        setSearchQuery("")
        const response = await axios.post("/api/recipe", { input: query });
        console.log("✅ Redirecting to:", response.data.id, response.data.title);
        navigate(`/recipe/${response.data.id}`, {
          state: { from: location.pathname + location.search, recipe: response.data },
        });
        setTimeout(() => setLoadingHttpSearch(false), 200);
      } else {
        // Merge the new search query with existing URL parameters, preserving any filters.
        const params = new URLSearchParams(location.search);
        params.set("search", query);
        navigate(`/discover?${params.toString()}`);
      }
    } catch (err) {
      console.error("❌ Search API Error:", err);
      addNotification("Search Error", "Failed to fetch recipe. Try a different one.", "error");
      setLoadingHttpSearch(false);
    }
    // Do not clear the search query here; the clear button handles that.
  };

  const handleUserRecipeSearch = async (query) => {
    if (query === undefined) return;
    if (!query.startsWith("http") && query.length > 100) {
      addNotification("Search Error", "Search query cannot exceed 100 characters.", "error");
      return;
    }

    try {
      const params = new URLSearchParams(location.search);
      params.set("search", query);
      navigate(`/my-recipes?${params.toString()}`);
    } catch (err) {
      console.error("❌ Search API Error:", err);
      addNotification("Search Error", "Failed to fetch recipe. Try a different one.", "error");
    }
    // Do not clear the search query here; the clear button handles that.
  };

  return (
    <SearchContext.Provider value={{ searchQuery, setSearchQuery, handleSearch, loadingHttpSearch, handleUserRecipeSearch, userSearchQuery, setUserSearchQuery }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  return useContext(SearchContext);
}
